import { render, staticRenderFns } from "./RateStore.vue?vue&type=template&id=6dd860b0&scoped=true&"
import script from "./RateStore.vue?vue&type=script&lang=js&"
export * from "./RateStore.vue?vue&type=script&lang=js&"
import style0 from "./RateStore.vue?vue&type=style&index=0&id=6dd860b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd860b0",
  null
  
)

export default component.exports